// extracted by mini-css-extract-plugin
export var actions = "_e2-g";
export var benefitCard = "_e2-b";
export var benefitIcon = "_e2-d";
export var benefitLabel = "_e2-f";
export var benefits = "_e2-a";
export var benefitsSection = "_e2-8";
export var bodyText = "_e2-7";
export var closeButton = "_e2-2";
export var content = "_e2-3";
export var eyebrow = "_e2-4";
export var heading = "_e2-5";
export var image = "_e2-i";
export var imagePanel = "_e2-h";
export var modal = "_e2-0";
export var offerCard = "_e2-c";
export var offerIcon = "_e2-e";
export var sectionLabel = "_e2-9";
export var shell = "_e2-1";
export var title = "_e2-6";